<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="icon-featur-grid-title" :field="fields?.title" tag="h2" />
      <JssRichText class="icon-featur-grid-desc" :field="fields?.subtitle" />
      <div class="icon-featur-grid-content" v-if="fields?.list?.length > 0">
        <div class="icon-featur-grid-content-list" :style="{ '--pc-columns': 3 }">
          <siteLink
            class="icon-featur-grid-content-item"
            v-for="item in fields?.list"
            :key="item?.id"
            :link="item?.fields?.link"
          >
            <AdaptiveImage
              class="icon-featur-grid-content-item-image"
              :field="item?.fields?.image"
              :isBackground="false"
              :lazy-load="false"
              :enableScrollDetection="false"
              :show="true"
            />
            <JssRichText
              class="icon-featur-grid-content-item-title"
              :field="item?.fields?.title"
              tag="h3"
            />
          </siteLink>
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'IconFeatureGrid',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'icon-featur-grid'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.icon-featur-grid {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    text-align: center;
  }

  &-desc {
    font-size: 14px;
    line-height: 1.6;
    color: $black;
    margin-top: 8px;
    text-align: center;
  }

  &-content {
    width: 100%;
    margin-top: 24px;
    &-list {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
      width: 100%;
    }

    &-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      padding: 16px;
      text-align: center;
      background-color: #f8f9f8;
      border-radius: 16px;

      &-title {
        font-size: 14px;
        color: $black;
        font-weight: 500;
      }

      &-image {
        width: 40px;
        height: 40px;
      }
    }
  }

  @include tablet {
    &-desc {
      font-size: 18px;
    }

    &-content {
      margin-top: 40px;

      &-item {
        flex-direction: row;
        text-align: left;
        gap: 16px;

        &-title {
          font-size: 16px;
        }

        &-image {
          width: 44px;
          height: 44px;
        }
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-content {
      @include grid-block(3, 20);

      &-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 24px;
        width: 100%;
      }

      &-item {
        display: flex;
        align-items: center;
        gap: 24px;
        padding: 24px;
        flex: 0 0 calc((100% - (var(--pc-columns, 3) - 1) * 24px) / var(--pc-columns, 3));
        max-width: calc((100% - (var(--pc-columns, 3) - 1) * 24px) / var(--pc-columns, 3));

        &-title {
          font-size: 18px;
          color: $black;
        }

        &-image {
          width: 48px;
          height: 48px;
        }
      }
    }
  }
}
</style>
